module.exports = __webpack_public_path__ + "static/CBRN_HYMOTS_TEAM-7b1ebb30389172d06eeebb0c3a7dce83.jpeg";